import React, { useState } from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ rating = 0, onRate, readonly = false, size = 'md' }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const handleClick = (value) => {
    if (!readonly && onRate) {
      onRate(value);
    }
  };

  return (
    <div className="star-rating" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((value) => {
        const isFilled = value <= (hoverRating || rating);
        
        return (
          <button
            key={value}
            type="button"
            onClick={() => handleClick(value)}
            onMouseEnter={() => !readonly && setHoverRating(value)}
            onMouseLeave={() => !readonly && setHoverRating(0)}
            disabled={readonly}
            className={`star ${isFilled ? 'filled' : 'empty'} ${
              readonly ? 'cursor-default' : 'cursor-pointer'
            }`}
            data-testid={`star-${value}`}
          >
            <Star
              className={`${sizeClasses[size]} ${isFilled ? 'fill-current' : ''}`}
            />
          </button>
        );
      })}
    </div>
  );
};

// Display-only rating with count
export const RatingDisplay = ({ rating, count }) => (
  <div className="flex items-center gap-2" data-testid="rating-display">
    <div className="flex items-center gap-1 text-[#8B5CF6]">
      <Star className="w-4 h-4 fill-current" />
      <span className="font-semibold">{rating.toFixed(1)}</span>
    </div>
    {count !== undefined && (
      <span className="text-sm text-gray-400">({count} ratings)</span>
    )}
  </div>
);
